import {IDownloadReverseDnsListFileIntAction} from '../actions/export-reverse-dns-list-int'
import {IServicePerformanceState} from '../state'

export type IDownloadReverseDnsListIntAction = IDownloadReverseDnsListFileIntAction

export const exportReverseDnsIntReducer = (
  state: IServicePerformanceState,
  action: IDownloadReverseDnsListIntAction,
) => {
  return {
    ...state,
    exportReverseDnsIntStatus: {
      ...state.exportReverseDnsIntStatus,
      status: action.status,
    },
  }
}
